"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get generatePackageTask () {
        return generatePackageTask;
    },
    get infoAction () {
        return infoAction;
    }
});
const _createTargetGraph = require("../run/createTargetGraph.js");
const _filterArgsForTasks = require("../run/filterArgsForTasks.js");
const _config = require("@lage-run/config");
const _workspacetools = require("workspace-tools");
const _getFilteredPackages = require("../../filter/getFilteredPackages.js");
const _logger = /*#__PURE__*/ _interop_require_default(require("@lage-run/logger"));
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _shellquote = require("shell-quote");
const _targetgraph = require("@lage-run/target-graph");
const _initializeReporters = require("../initializeReporters.js");
const _runners = require("@lage-run/runners");
const _getBinPaths = require("../../getBinPaths.js");
const _runnerPickerOptions = require("../../runnerPickerOptions.js");
const _parseServerOption = require("../parseServerOption.js");
const _optimizeTargetGraph = require("../../optimizeTargetGraph.js");
const _globby = require("@lage-run/globby");
const _hasher = require("@lage-run/hasher");
const _targetHashFilePath = require("../targetHashFilePath.js");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function infoAction(options, command) {
    const cwd = process.cwd();
    const config = await (0, _config.getConfig)(cwd);
    const logger = (0, _logger.default)();
    options.logLevel = options.logLevel ?? "info";
    options.reporter = options.reporter ?? "json";
    options.server = typeof options.server === "boolean" && options.server ? "localhost:5332" : options.server;
    await (0, _initializeReporters.initializeReporters)(logger, options, config.reporters);
    const root = (0, _workspacetools.getWorkspaceRoot)(cwd);
    const packageInfos = (0, _workspacetools.getPackageInfos)(root);
    const { tasks, taskArgs } = (0, _filterArgsForTasks.filterArgsForTasks)(command.args);
    const targetGraph = await (0, _createTargetGraph.createTargetGraph)({
        logger,
        root,
        dependencies: options.dependencies,
        dependents: options.dependents && !options.to,
        ignore: options.ignore.concat(config.ignore),
        pipeline: config.pipeline,
        repoWideChanges: config.repoWideChanges,
        scope: (options.scope ?? []).concat(options.to ?? []),
        since: options.since,
        outputs: config.cacheOptions.outputGlob,
        tasks,
        packageInfos,
        priorities: config.priorities,
        enableTargetConfigMerging: config.enableTargetConfigMerging
    });
    const scope = (0, _getFilteredPackages.getFilteredPackages)({
        root,
        packageInfos,
        logger,
        includeDependencies: options.dependencies,
        includeDependents: options.dependents && !options.to,
        since: options.since,
        scope: (options.scope ?? []).concat(options.to ?? []),
        repoWideChanges: config.repoWideChanges,
        sinceIgnoreGlobs: options.ignore.concat(config.ignore)
    });
    const pickerOptions = (0, _runnerPickerOptions.runnerPickerOptions)(options.nodeArg, config.npmClient, taskArgs);
    const runnerPicker = new _runners.TargetRunnerPicker(pickerOptions);
    // This is a temporary flag to allow backwards compatibility with the old lage graph format used by BuildXL (formerly known as Domino).
    // I initially worked on a commandline flag, but threading that through requires 3 different releases (lage, buildxl, ohome).
    // This is a temp solution to be able to upgrade to Lage V2 without breaking the BuildXL integration. And allow us
    // to update to lage v2.
    // Unfortunately this is the only variable that we can use to not break any other customers
    const createBackwardsCompatGraph = process.env["DOMINO"] === "1" || !options.optimizeGraph;
    const optimizedTargets = await (0, _optimizeTargetGraph.optimizeTargetGraph)(targetGraph, runnerPicker, createBackwardsCompatGraph);
    const binPaths = (0, _getBinPaths.getBinPaths)();
    const packageTasks = optimizedTargets.map((target)=>generatePackageTask(target, taskArgs, config, options, binPaths, packageInfos, tasks));
    // In worker server mode, we need to actually speed up the BuildXL runs with presupplied global input hashes so that it doesn't try to read it over and over again
    // This is an important optimization for BuildXL for large amount of env glob matches in non-well-behaved monorepos
    // (e.g. repos that have files listed in env glob to avoid circular dependencies in package graph)
    if (shouldRunWorkersAsService(options)) {
        // For each target in the target graph, we need to create a global input hash file in this kind of location:
        // ${target.cwd}/.lage/global_inputs_hash
        // We will use glob for these files and use the FileHasher to generate these hashes.
        const fileHasher = new _hasher.FileHasher({
            root
        });
        const globHashCache = new Map();
        const globHashWithCache = (patterns, options)=>{
            const key = patterns.join("###");
            if (globHashCache.has(key)) {
                return globHashCache.get(key);
            }
            const files = (0, _globby.glob)(patterns, options);
            const hash = (0, _hasher.hashStrings)(Object.values(fileHasher.hash(files.map((file)=>_path.default.join(root, file)))));
            globHashCache.set(key, hash);
            return hash;
        };
        const globalInputs = config.cacheOptions?.environmentGlob ? (0, _globby.glob)(config.cacheOptions?.environmentGlob, {
            cwd: root
        }) : [
            "lage.config.js"
        ];
        for (const target of optimizedTargets){
            if (target.id === (0, _targetgraph.getStartTargetId)()) {
                continue;
            }
            const targetGlobalInputsHash = target.environmentGlob ? globHashWithCache(target.environmentGlob, {
                cwd: root
            }) : globHashWithCache(globalInputs, {
                cwd: root
            });
            const targetGlobalInputsHashFile = _path.default.join(target.cwd, (0, _targetHashFilePath.getGlobalInputHashFilePath)(target));
            const targetGlobalInputsHashFileDir = _path.default.dirname(targetGlobalInputsHashFile);
            // Make sure the directory exists
            if (!_fs.default.existsSync(targetGlobalInputsHashFileDir)) {
                _fs.default.mkdirSync(targetGlobalInputsHashFileDir, {
                    recursive: true
                });
            }
            // Write the hash to the file
            _fs.default.writeFileSync(targetGlobalInputsHashFile, targetGlobalInputsHash);
        }
    }
    const infoResult = {
        command: command.args,
        scope,
        packageTasks
    };
    if (options.outputFile) {
        const parentFolder = _path.default.dirname(options.outputFile);
        if (!_fs.default.existsSync(parentFolder)) {
            await _fs.default.promises.mkdir(parentFolder, {
                recursive: true
            });
        }
        const infoJson = JSON.stringify(infoResult, null, options.verbose ? 2 : undefined);
        await _fs.default.promises.writeFile(options.outputFile, infoJson);
        logger.info(`Wrote info to file: ${options.outputFile}`);
    } else {
        logger.info("info", infoResult);
    }
}
function generatePackageTask(target, taskArgs, config, options, binPaths, packageInfos, tasks) {
    const command = generateCommand(target, taskArgs, config, options, binPaths, packageInfos, tasks);
    const workingDirectory = getWorkingDirectory(target);
    const packageTask = {
        id: target.id,
        command,
        dependencies: target.dependencies,
        workingDirectory,
        package: target.packageName ?? "",
        task: target.task,
        inputs: target.inputs,
        outputs: target.outputs
    };
    if (target.weight && target.weight !== 1) {
        packageTask.weight = target.weight;
    }
    if (target.options && Object.keys(target.options).length != 0) {
        packageTask.options = target.options;
    }
    return packageTask;
}
function shouldRunWorkersAsService(options) {
    return typeof process.env.LAGE_WORKER_SERVER === "string" && process.env.LAGE_WORKER_SERVER !== "false" || !!options.server;
}
function generateCommand(target, taskArgs, config, options, binPaths, packageInfos, tasks) {
    if (target.type === "npmScript") {
        const script = target.packageName !== undefined ? packageInfos[target.packageName]?.scripts?.[target.task] : undefined;
        // If the script is a node script, and that it does not have any shell operators (&&, ||, etc)
        // then we can simply pass this along to info command rather than using npm client to run it.
        if (script && script.startsWith("node")) {
            const parsed = (0, _shellquote.parse)(script);
            if (parsed.length > 0 && parsed.every((entry)=>typeof entry === "string")) {
                return [
                    ...parsed,
                    ...taskArgs
                ];
            }
        }
        const npmClient = config.npmClient ?? "npm";
        const command = [
            npmClient,
            ...getNpmArgs(target.task, taskArgs)
        ];
        return command;
    } else if (target.type === "worker" && shouldRunWorkersAsService(options)) {
        const { host, port } = (0, _parseServerOption.parseServerOption)(options.server);
        const command = [
            binPaths["lage"],
            "exec",
            "--tasks",
            ...tasks,
            "--server",
            `${host}:${port}`
        ];
        if (options.concurrency) {
            command.push("--concurrency", options.concurrency.toString());
        }
        if (target.packageName) {
            command.push(target.packageName);
        }
        if (target.task) {
            command.push(target.task);
        }
        command.push(...taskArgs);
        return command;
    } else if (target.type === "worker") {
        const command = [
            binPaths.lage,
            "exec"
        ];
        command.push(target.packageName ?? "");
        command.push(target.task);
        command.push(...taskArgs);
        return command;
    }
    return [];
}
function getWorkingDirectory(target) {
    const cwd = process.cwd();
    const workingDirectory = _path.default.relative((0, _workspacetools.getWorkspaceRoot)(cwd) ?? "", target.cwd).replace(/\\/g, "/");
    return workingDirectory;
}
function getNpmArgs(task, taskTargs) {
    const extraArgs = taskTargs != undefined && taskTargs.length > 0 ? [
        "--",
        ...taskTargs
    ] : [];
    return [
        "run",
        task,
        ...extraArgs
    ];
}
